import React from 'react';
import startCase from 'lodash/startCase';
import { Alert } from 'antd';
import toLower from 'lodash/toLower';
import {
  GarageInfoStyled,
  garageInfoLayout,
  garageInfoCol,
  ViewGarageLink,
  StyledPopoverContent,
  StyledPopoverTitle,
} from './styled';

const upf = (val) => startCase(toLower(val));

export default function GarageInfo({ garage }) {
  const {
    garageId,
    addressLine1,
    addressLine2,
    county,
    postcode,
    contactFirstName,
    contactLastName,
    email,
    contactPhone,
    openingHour,
    closingHour,
    businessName,
    canPerformAllWorkForBooking,
  } = garage;

  if (!garage) return null;

  const content = () => (
    <StyledPopoverContent>
      <div style={garageInfoLayout}>
        <div style={garageInfoCol}>
          <h3>Address</h3>
          <div>{upf(addressLine1)}</div>
          <div>{upf(addressLine2)}</div>
          <div>{upf(county)}</div>
          <div>{postcode}</div>
        </div>
        <div style={garageInfoCol}>
          <h3>Contact</h3>
          <div>
            {upf(contactFirstName)} {upf(contactLastName)}
          </div>
          <div>{email}</div>
          <div>
            <b>{contactPhone}</b>
            <br />
          </div>
        </div>

        <div style={garageInfoCol}>
          <h3>Opening Time</h3>
          <div>{openingHour}</div>
        </div>
        <div style={garageInfoCol}>
          <h3>Closing Time</h3>
          <div>{closingHour}</div>
        </div>
      </div>

      {canPerformAllWorkForBooking === false && (
        <Alert message="This garage can&#39;t perform one or more of the work operations" type="warning" />
      )}
    </StyledPopoverContent>
  );

  const title = (
    <StyledPopoverTitle>
      <span style={{ fontSize: 16 }}>{upf(businessName)}</span>
      <ViewGarageLink target="_blank" href={`/garages/${garageId}`} rel="noreferrer">
        View Garage
      </ViewGarageLink>
    </StyledPopoverTitle>
  );

  return (
    <GarageInfoStyled content={content()} title={title} placement="right" trigger="hover">
      {upf(businessName)}
    </GarageInfoStyled>
  );
}
